import React from 'react';
import { Link } from 'react-router-dom';

const Routes = () => {
  return (
    <>
     <Link to={`/components/avatar`}>
        <li>Avatar</li>
      </Link>
      <Link to={`/components/badge`}>
        <li>Badge</li>
      </Link>
      <Link to={`/components/button`}>
        <li>Button</li>
      </Link>
      <Link to={`/components/image`}>
        <li>Image</li>
      </Link>
      <Link to={`/components/link`}>
        <li>Link</li>
      </Link>
      <Link to={`/components/search`}>
        <li>Search</li>
      </Link>
      <Link to={`/components/skeleton`}>
        <li>Skeleton</li>
      </Link>
      <Link to={`/components/spinner`}>
        <li>Spinner</li>
      </Link>
      <Link to={`/components/text-input`}>
        <li>Text Input</li>
      </Link>
      
    </>
  );
};

export default Routes;
